'use client';

import * as React from 'react';

import { ResourceBadge } from '@/components/ui/resource-badge';
import { formatMoney } from "@/lib/money";
import { useOrgNavigate } from '@/hooks/use-app-navigate';

interface PaymentResourceBadgeProps {
  paymentId: string;
  amount?: number;
  currency?: string;
  variant?: 'default' | 'secondary' | 'destructive' | 'outline';
  className?: string;
}

/**
 * PaymentResourceBadge component for displaying payment information
 * Inherits from generic ResourceBadge
 */
export function PaymentResourceBadge({
  paymentId,
  amount,
  currency = 'USD',
  variant = 'secondary',
  className,
}: PaymentResourceBadgeProps) {
  const { orgRoutes } = useOrgNavigate();
  // Format display value based on available data
  const displayValue = React.useMemo(() => {
    if (amount !== undefined) {
      return formatMoney(amount, currency);
    }
    return `${paymentId.substring(0, 8)}...`;
  }, [amount, currency, paymentId]);

  return (
    <ResourceBadge
      name="payment"
      value={displayValue}
      appLink={orgRoutes.PAYMENT_DETAILS(paymentId)}
      variant={variant}
      className={className}
    />
  );
}
